import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { dateFormat } from '@carm/shared/constants/const-carm';
import { LoaderSpinnerTypes } from '@carm/_core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { IBaseResponse } from '@carm/_utils/models';
import * as dayjs from 'dayjs';
import { Observable } from 'rxjs';
import {
  IAgreementHistoryResponse,
  IPadInfo,
  IPreAuthorizedDebitResponse,
  IBankInfoResponse,
} from '../models';

@Injectable()
export class PreAuthorizeDebitService extends BaseApiService {
  constructor(protected injector: Injector) {
    super(injector);
  }
  get financialPadUrl(): string {
    return `${this.endPointBP}/financial/pad`;
  }

  public getPreAuthorizedDebit(loaderSpinnerService: LoaderSpinnerTypes): Observable<IPreAuthorizedDebitResponse> {
    const endPoint = `${this.financialPadUrl}`;
    return this.httpAuthGet<IPreAuthorizedDebitResponse>(endPoint, null, loaderSpinnerService);
  }

  public getAgreementHistory(): Observable<IAgreementHistoryResponse> {
    const endPoint = `${this.financialPadUrl}/history`;
    return this.httpAuthGet<IAgreementHistoryResponse>(endPoint);
  }

  public getAgreementHistoryFile(docId: string): Observable<Blob> {
    const url = `${this.financialPadUrl}/agreement/${docId}`;
    return this.httpAuthDownloadFile(url);
  }

  public cancelPreAuthorizedDebut(
    effectiveDate: Date
  ): Observable<IBaseResponse> {
    const url = `${this.financialPadUrl}`;

    const params = new HttpParams().set(
      'effectiveDate',
      dayjs(effectiveDate).format(dateFormat)
    );

    return this.httpAuthDelete<IBaseResponse>(url, params);
  }

  public submitPad(padInfoBody: IPadInfo): Observable<IBaseResponse> {
    const endPoint = `${this.financialPadUrl}`;
    return this.httpAuthPost<IBaseResponse>(endPoint, padInfoBody);
  }

  public getBankInfo(bankNumber: string): Observable<IBankInfoResponse> {
    const endPoint = `${this.financialPadUrl}/bank/${bankNumber}`;
    return this.httpAuthGet<IBankInfoResponse>(endPoint);
  }
}
